import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState, RootState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { data } from "../data";
import { Dropdown } from "./helpers/constants";

import { onChange } from "./helpers/on-change"
import { GetFontFamilyList } from "./helpers/getFontFamilyList";
import { FormCreationData } from "../../../../../../stateManager/store/formCreation_v2/types";
import { useParams } from "react-router";
import { fetchAllStaticAssetsByFiletype } from "../../../../../../stateManager/store/static-assets/action";
import { getComputedValues } from "../../helpers/formsv3/getComputedValues";

const DEFAULT_FONT_FAMILY: string = "properties.styles.common.fontFamily";
const DEFAULT_FONT_FAMILY_V3: string = "properties.styles.$deviceType.fontFamily";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: any;
}

const excluded_types = [
  "ExpansionPanel",
  "Row",
  "Column",
  "Divider",
  "Grid",
  "Modal",
  "CustomModal"
]

export const FontFamily = (props: Props) => {
  const { components } = getComponents()
  const selectedElementId = useSelector((state: AppState) => state.formJson.selectedElementId)
  const deviceType = useSelector((state: AppState) => state.formJson.deviceType)
  const isCoreV3 = useSelector((state: AppState) => state.formJson.isCoreV3)
  const computedStyles = useSelector((state: AppState) => state.formJson.computedStyles)
  const wrapperComputedStyles = useSelector((state: AppState) => state.formJson.wrapperComputedStyles)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component: FormCreationData = components[selectedElementId];
  const { type } = component;
  const optionList = GetFontFamilyList();

  useEffect(() => {
    if (isCoreV3 && component) {
      var previousValue = getValue(component, DEFAULT_FONT_FAMILY_V3.split("."), deviceType);
      if (previousValue) {
        const mergedArray = [...optionList?.customFonts, ...optionList?.systemFonts]
        if (mergedArray.length > 0 && !mergedArray.some((s: any) => s.name === previousValue)) {

          onChange({
            path: DEFAULT_FONT_FAMILY_V3,
            value: "Inherit",
            oldValue: previousValue,
            setOldValue,
            selectedElementId
          })
          previousValue = "Inherit"
        }
        setValue(previousValue)
        setOldValue(previousValue)
      } else {
        const wrapperStyles = wrapperComputedStyles.hasOwnProperty("fontFamily") ? wrapperComputedStyles : computedStyles;
        const fontFamily = (wrapperStyles && wrapperStyles.fontFamily ? wrapperStyles.fontFamily.split(",")[0] : null);
        setValue(fontFamily)
        setOldValue(fontFamily)
      }
    } else if (!isCoreV3 && component) {
      var previousValue = getValue(component, DEFAULT_FONT_FAMILY.split("."), deviceType);
      if (previousValue) {
        const mergedArray = [...optionList?.customFonts, ...optionList?.systemFonts]
        if (mergedArray.length > 0 && !mergedArray.some((s: any) => s.name === previousValue)) {

          onChange({
            path: DEFAULT_FONT_FAMILY,
            value: "Inherit",
            oldValue: previousValue,
            setOldValue,
            selectedElementId
          })
          previousValue = "Inherit"
        }
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  if (isCoreV3 && excluded_types.includes(type)) {
    return null;
  }

  return (
    <div className="panel-div">
      <label
        htmlFor="FontFamily"
        className="panel-label"
      >
        {label}
      </label>
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={
          optionList
        }
        type="fontFamily"
        selected={{ name: value }}
        onChange={(option) => {
          const merggedArray = [...optionList?.customFonts, ...optionList?.systemFonts]
          const item = merggedArray.find((item: any) => item.name === option.name)
          if (item) {
            const value = item.name
            setValue(value)
            onChange({
              path: isCoreV3 ? DEFAULT_FONT_FAMILY_V3 : DEFAULT_FONT_FAMILY,
              value,
              oldValue,
              setOldValue,
              selectedElementId
            })
          }
        }}
      />
    </div>
  )
};

export const FontFamilyV3 = (props: Props) => {
  const { components } = getComponents()
  const params: { appId: string } = useParams();
  const dispatch = useDispatch()
  const orgId = useSelector((state: AppState) => state.org.selectedOrg.id);
  const selectedElementId = useSelector((state: AppState) => state.formJson.selectedElementId)
  const deviceType = useSelector((state: AppState) => state.formJson.deviceType)
  const isCoreV3 = useSelector((state: AppState) => state.formJson.isCoreV3)
  const fontFiles = useSelector((state: RootState) => state.staticAssets.fonts)


  const { isCheckedIn, defaultValue = { name: "Default", url: "" }, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component: FormCreationData = components[selectedElementId];
  const { type } = component;
  const optionList = GetFontFamilyList();

  const [fontList, setFontList] = useState<{ name: string; url: string; }[]>([])

  const fetchFontFiles = () => {
    const payload = {
      "appId": params.appId,
      "filetype": "font",
      orgId
    }
    dispatch(fetchAllStaticAssetsByFiletype(payload))
  }

  useEffect(() => {
    fetchFontFiles();
  }, [])

  useEffect(() => {
    if (isCoreV3 && component) {
      var previousValue = getValue(component, DEFAULT_FONT_FAMILY_V3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else {
        const wrapperStyles = getComputedValues(selectedElementId) as React.CSSProperties
        const fontFamily = (wrapperStyles && wrapperStyles.fontFamily ? wrapperStyles.fontFamily.split(",")[0] : { name: "Default", url: "" });
        setValue(fontFamily)
        setOldValue("Default")
      }
    } 
  }, [isCoreV3, component, deviceType]);

  useEffect(() => {
    if (Object.values(fontFiles)) {
      const list = Object.values(fontFiles).map((font: any) => {
        return { name: font.filename, url: font.url }
      })
      list.unshift({ name: "Default", url: "" })
      setFontList(list)
    }
  }, [fontFiles])

  if (excluded_types.includes(type)) {
    return null;
  }

  return (
    <div className="panel-div">
      <label
        htmlFor="FontFamily"
        className="panel-label"
      >
        {label}
      </label>
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={{ systemFonts: fontList }}
        type="fontFamily"
        selected={value || { name: "", url: "" }}
        onChange={(option) => {
          // const merggedArray = [...optionList?.customFonts, ...optionList?.systemFonts]
          // const item = merggedArray.find((item: any) => item.name === option.name)
          if (option) {
            setValue(option)
            onChange({
              path: isCoreV3 ? DEFAULT_FONT_FAMILY_V3 : DEFAULT_FONT_FAMILY,
              value: option,
              oldValue,
              setOldValue,
              selectedElementId
            })
          }
        }}
      />
    </div>
  )
};
